<template>
  <div class="content">
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="24">  
        <el-col :span="7"><div class="search-area-div1">月份：{{tableData.customerName}}</div> </el-col> 
         <el-col :span="5"><div class="search-area-div1">批次：{{tableData.terminalProperty}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">提报金额：{{tableData.customerCode | getDate}}</div> </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">提报组织：{{tableData.contacts}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div1">提报人：{{tableData.contactTel}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">提报人岗位：{{tableData.address}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="24"> 
        <el-col :span="5"><div class="search-area-div1">提报时间：{{tableData.contactTel}}</div> </el-col>   
      </el-row> 
    </div> 
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
    <div class="w100f t-left mb15">
    <b>提报明细</b>
    </div>
      <el-table :data="tableData.orderDetailVOs" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="goodsCode" label="人员" header-align="center"  width="100" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="组织" header-align="center" width="100" align="center"></el-table-column> 
        <el-table-column prop="goodsSpec" label="岗位" header-align="center" width="100" align="center"></el-table-column>
        <el-table-column prop="unitStyle" label="推广费(元)" header-align="center" width="100" align="right">
          <template slot-scope="scope">{{scope.row.unitStyle | numDigit | numFmt}}</template>
        </el-table-column>
        <el-table-column prop="producer" label="手机号" header-align="center" width="100" align="center"></el-table-column>
        <el-table-column prop="bigUnitQty" label="身份证号" header-align="center" width="150" align="right"></el-table-column> 
        <el-table-column prop="price" label="推广费发放主体(代征公司)"  width="200" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.price | numFmt | numDigit }}</template>
        </el-table-column> 
        <el-table-column prop="qty" label="账户" header-align="center" align="center" width="200"></el-table-column> 
        <el-table-column prop="amount" label="开户行" header-align="center" align="center"  width="200">
          <template slot-scope="scope">{{ scope.row.amount | numFmt | numDigit }}</template>
        </el-table-column> 
        <el-table-column prop="qty" label="上报照片数(推广费月份)" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column prop="qty" label="上报订单数(推广费月份)" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column prop="qty" label="上报业绩(推广费月份)" width="200" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">详情</a> 
          </template>
        </el-table-column> -->
      </el-table> 
      
    </div>   
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 30, 50]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   -->

  </div>
</template>

<script>
export default {
  data() {
    return { 
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      },
      tableData: [],  
      timeList:'',
      tableLoading:false
    };
  },
  created() {
    // 列表
    this.getData(false);
  }, 
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      };
      self.getData(true);
    }, 
    getData(flg) {
      let self = this; 
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msPurchaseService}/order/data/get-order-detail?`+`guid=`+self.$router.history.current.query.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },   
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
<style scoped>
.search-area-div1{
  text-align: left;
  margin-bottom: 10px;
}
</style>